import type { RingsToPathData } from "./types";

// One closed subpath per ring, written straight into one string: no arrays in between.
export const ringsToPathData: RingsToPathData = (rings) => {
  let pathData = "";
  for (const ring of rings) {
    if (ring.length === 0) continue;
    for (let index = 0; index < ring.length; index += 1) {
      const point = ring[index];
      pathData += `${index === 0 ? "M" : "L"}${point.x} ${point.y}`;
    }
    pathData += "Z";
  }
  return pathData;
};
